import React from "react";

function Footer1xbet() {
  return (
    <div className="flex items-center justify-center h-[50px] bg-cripten-dark w-full" />
  );
}

export default Footer1xbet;
